exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-open-users{border-radius:4px!important;background-color:#3598dc;height:33px;width:auto;text-align:center;color:#fff;border:none;margin-left:17px;float:right;position:absolute;right:16px;top:15px;padding:0 17px}.btn-open-users:hover{background:#054f91}.vdp-datepicker{display:inline-block;width:90%}.vdp-datepicker input{border:1px solid #ccc;border-radius:5px;height:34px;width:100%;padding:0 10px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58c7fa66","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/allCompany/pinList.vue
// module id = 775
// module chunks = 0